import { IMAGE_LIST } from "./imgList";
export {
  IMAGE_LIST
};

export const ERRORS = {
  ERROR_401: 'ERROR_401',
  ERROR_500: 'ERROR_500',
  ERROR_BIZ: 'ERROR_BIZ',
};

// 黄色的圆形logo
export const LOGO_NEW_CIRCLE = 'https://image.ctssha.com/file/2022/11/30/JjvjEcxa7DjKFF9qVp.png';
// 中旅logo(中国旅游集团成员+中旅总社上海)
export const LOGO_COMPANIES = 'https://image.ctssha.com/file/2022/07/26/Updj3BUq1xh4XsZzX8.png';
// 商品默认图
export const GOODS_DEFAULT = 'https://image.ctssha.com/file/2023/06/27/ll7Emb65L6zFVHCzGK.jpg';

// 协议类型
export const PROTOCOL_TYPE = {
  'user': '用户协议',
  'privacy': '隐私协议'
}

export const PROD_TYPE = {
  'GTY': '跟团游',
  'ZYX': '自由行',
  'XCY': '携宠游',
  'JD': '酒店',
  'PQ': '票券',
  'SW': '实物',
  'QZ': '签证'
}

export const PROD_ATTACH_TYPE = {
  'fybh': '费用包含',
  'fybbh': '费用不包含',
  'etsm': '儿童说明',
  'lrsm': '老人说明',
  'fcsm': '房差说明',
  'tksm': '退款说明',
  'lffgwsm': '另付费/购物说明',
  'qzxx': '签证信息',
  'yysm': '预约说明',
  'qtsm': '其他说明',
  'cxxz': '出行须知',
  'lcsm': '流程说明',
  'tssm': '特殊说明',
}

export const WEEK_LIST = ['日', '一', '二', '三', '四', '五', '六']

export const PROTOCOL_TITLE = {
  'user': '用户服务协议',
  'privacy': '隐私协议'
}

export const PROTOCOL_ENGLISH = {
  'user': 'User agreement',
  'privacy': 'Privacy policy'
}

export const USER_SEX = {
  1: '男',
  2: '女'
}

// [云闪付]底bar
export const YSF_TAB_BAR_LIST = [{
  path: "/",
  title: "首页",
  iconPath: 'https://image.ctssha.com/file/2022/10/25/64Ra5t13eQT67FcW1B.png',
  selectedIconPath: 'https://image.ctssha.com/file/2022/10/25/81Trad68JHlI9z4yiN.png'
}, {
  path: "/user/userCenter",
  title: "我的",
  iconPath: 'https://image.ctssha.com/file/2022/10/25/BMPN52jFW3WwMEnXnu.png',
  selectedIconPath: 'https://image.ctssha.com/file/2022/10/25/jmVy5vkHkzc7st9G5g.png'
}]

// [H5商城]底bar
export const SHOP_TAB_BAR_LIST = [{
  path: "/",
  title: "首页",
  iconPath: 'https://image.ctssha.com/file/2022/10/25/64Ra5t13eQT67FcW1B.png',
  selectedIconPath: 'https://image.ctssha.com/file/2023/03/31/2gSIoHCof5rJOu50L5.png'
}, {
  path: "/destination",
  title: "目的地",
  iconPath: 'https://image.ctssha.com/file/2023/03/31/9CVNupug6YRE3soEXY.png',
  selectedIconPath: 'https://image.ctssha.com/file/2023/03/31/AO6LTTRF2EDdigzJgy.png'
}, {
  path: "/user/userCenter",
  title: "我的",
  iconPath: 'https://image.ctssha.com/file/2022/10/25/BMPN52jFW3WwMEnXnu.png',
  selectedIconPath: 'https://image.ctssha.com/file/2023/03/31/zZ1mF9dJaG9mgByPgm.png'
}]

// 我的订单 列表
export const ORDER_TYPE_LIST = [{
  type: 10,
  title: '出行',
  iconSrc: 'https://image.ctssha.com/file/2022/10/25/Ah8DOwvUa495VQk1l2.png',
  eName: 'gty',
  mark: 'gtyMark'
}, {
  type: 40,
  title: '酒店',
  iconSrc: 'https://image.ctssha.com/file/2022/10/25/DwlrPEtfD43gR3LX06.png',
  eName: 'jd',
  mark: 'jdMark'
}, {
  type: 30,
  title: '票券',
  iconSrc: 'https://image.ctssha.com/file/2022/10/25/NXLsCFaM4VMmD9xOYp.png',
  eName: 'pq',
  mark: 'pqMark'
}, {
  type: 50,
  title: '商品',
  iconSrc: 'https://image.ctssha.com/file/2022/10/25/rLWQhfM6IuHuTjlfLw.png',
  eName: 'sw',
  mark: 'swMark'
}, {
  type: 60,
  title: '签证',
  iconSrc: 'https://image.ctssha.com/file/2022/12/27/TLQCYvuFrA6iL7bsFE.png',
  eName: 'qz',
  mark: 'qzMark'
}]

// [云闪付]我的工具 列表
export const YSF_MINE_TOOL_LIST = [{
  type: 'CXR',
  title: '出行人管理',
  iconName: 'cxr',
  href: '/user/travelerList'
}, {
  type: 'ADDRESS',
  title: '地址管理',
  iconName: 'shdz',
  href: '/user/addressList'
}];

// [H5商城]我的工具 列表
export const SHOP_MINE_TOOL_LIST = [{
  type: 'CXR',
  title: '出行人管理',
  iconName: 'cxr',
  href: '/user/travelerList'
}, {
  type: 'ADDRESS',
  title: '地址管理',
  iconName: 'shdz',
  href: '/user/addressList'
}, {
  type: 'YJFK',
  title: '意见反馈',
  iconName: 'yjfk',
  href: '/user/feedback'
}];

// [H5商城]推荐
export const SHOP_RECOMMEND_TOOL_LIST = [{
  type: '0',
  title: '星玩家',
  url: 'https://image.ctssha.com/file/2023/04/12/L9PGUgkHpoTqQr0FHP.png',
  href: '/user/recommendStarPlayer'
}, {
  type: '1',
  title: '中旅总社上海',
  url: 'https://image.ctssha.com/file/2023/04/12/YreK2uDRK89DEylLdV.png',
  href: '/user/recommendTravelSh'
}, {
  type: '2',
  title: '福利官',
  url: 'https://image.ctssha.com/file/2023/04/12/Xyw3KLX3mkhfci9jDc.png',
  href: '/user/recommendWelfareOfficer'
}, {
  type: '3',
  title: '关于我们',
  url: 'https://image.ctssha.com/file/2023/04/12/b30k0FrbshjPi0m1am.png',
  href: '/user/recommendAboutUs'
}];

// 小程序路径与H5商城路径转化字典
export const MINIPROGRAM_PATH_DIC = {
  '/pages/index/index': '/',
  '/pages/mine/mine': '/user/userCenter',
  '/pages/subject/subject': '/subject',
  '/pages/prod-detail/prod-detail': '/prodDetail',
  '/pages/destination/destination': '/destination',
  '/retail/prodDetail': '/retail/prodDetail',
  '/pages/pet/pet-home/pet-home': '/pet/petHome',
  '/pages/pet/pet-product/pet-product': '/pet/petProduct',
  '/pages/pet/pet-goods/pet-goods': '/pet/PetGoods',
}

export const PET_ORDER_LIST = [{
  type: 10,
  title: '待付款',
  iconImg: IMAGE_LIST['pet-order-dfk'],
  eName: 'dfk'
}, {
  type: 20,
  title: '已付款',
  iconImg: IMAGE_LIST['pet-order-yfk'],
  eName: 'yfk'
}, {
  type: 40,
  title: '待收货',
  iconImg: IMAGE_LIST['pet-order-dsh'],
  eName: 'dsh'
}, {
  type: 60,
  title: '已完成',
  iconImg: IMAGE_LIST['pet-order-ywc'],
  eName: 'ywc'
}];

export const PET_EDIT_TYPE = [{
  type: 1,
  title: '狗狗',
  iconImg: IMAGE_LIST['pet-maomao'],
  eName: 'maomao'
}, {
  type: 2,
  title: '猫猫',
  iconImg: IMAGE_LIST['pet-gougou'],
  eName: 'gougou'
}, {
  type: 9,
  title: '其他',
  iconImg: IMAGE_LIST['pet-qita'],
  eName: 'qita'
}];